<template>
  <v-main>
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span>API调试</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" outlined :href="DocLink.API" target="_blank">文档</v-btn>
    </v-app-bar>
    <v-container fluid>
      <v-select class="mt-4" :items="apiList" outlined label="接口名称" v-model="form.api" />
      <v-textarea
        outlined
        auto-grow
        label="请求参数（JSON格式）"
        hint=""
        class="required form-params"
        v-model="form.params"
      />
      <v-btn width="100%" color="primary" class="mt-2" :loading="isLoading" @click="onSubmit">发送请求</v-btn>
      <div class="response mt-8" v-if="responseStatus">
        <div class="response-status mb-2">
          <span class="label">响应状态码: </span>
          <span class="value">{{ responseStatus }}</span>
        </div>
        <v-divider></v-divider>
        <pre class="response-body mt-2">{{ responseBody }}</pre>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { projectStore } from '@/store/project'
import { homeStore } from '@/store/home'
import { DocLink } from '@/plugins/doc'
import { EzrevenueClient } from '@/plugins/ezrevenueClient'

const BASE_URL = window.location.origin + '/api/v1/server'

const API_LIST = [
  {
    text: 'customer.info 获取用户信息',
    value: 'customer.info',
  },
  {
    text: 'customer.consume 用户进行消费',
    value: 'customer.consume',
  },
  {
    text: 'redeem_code.exchange 用户使用兑换码',
    value: 'redeem_code.exchange',
  },
  {
    text: 'customer.get_promoter_key 获取推广员短码',
    value: 'customer.get_promoter_key',
  },
  {
    text: 'customer.visit_promoter_key 查询推广员短码',
    value: 'customer.visit_promoter_key',
  },
]

export default {
  name: 'ApiDebugPage',
  components: { AppbarBackIcon },
  data() {
    return {
      DocLink,
      apiList: API_LIST,
      form: {
        api: API_LIST[0].value,
        params: '{\n\n}',
      },
      isLoading: false,
      responseStatus: null,
      responseBody: null,
    }
  },
  computed: {
    project() {
      return projectStore.current
    },
  },
  async mounted() {
    await homeStore.doLoad()
  },
  methods: {
    async onSubmit() {
      this.responseStatus = null
      this.responseBody = null
      this.isLoading = true
      let client = EzrevenueClient({
        baseUrl: BASE_URL,
        projectId: this.project.id,
        projectSecret: this.project.secret,
      })
      try {
        let params = JSON.parse(this.form.params)
        let response = await client.call(this.form.api, params)
        this.responseStatus = response.status
        this.responseBody = JSON.stringify(response.data, null, 2)
      } catch (err) {
        this.responseStatus = '请求失败'
        this.responseBody = String(err)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.form-params {
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
}
.response {
  .response-status {
    .label {
      font-weight: bold;
    }
    .value {
      font-family: monospace;
      font-weight: bold;
    }
  }
  .response-body {
    min-height: 48px;
    font-family: monospace;
    white-space: pre-wrap;
    word-break: break-all;
  }
}
</style>
